import React from 'react';
import { useSelector } from 'react-redux';

import HomeworkTableAdmin from 'Components/HomeworkTables/HomeworkTableAdmin';
import HomeworkTableTeacher from 'Components/HomeworkTables/HomeworkTableTeacher';

import { getUserType } from '../../redux/slices/userSlice';

interface Props {
  mail: string;
}

export default function HomeworkTable({ mail }: Props) {
  const userTypeSelector = useSelector(getUserType);

  if (userTypeSelector === 'Teacher') {
    return <HomeworkTableTeacher mail={mail} />;
  } else {
    return <HomeworkTableAdmin />;
  }
}
